import { render, staticRenderFns } from "./FacilityInfo.vue?vue&type=template&id=6157b285&"
import script from "./FacilityInfo.vue?vue&type=script&lang=js&"
export * from "./FacilityInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports